module.exports = __webpack_public_path__ + "img/note.6ea93616.svg";